<img [src]="'assets/icons/' + this.name + '.png'" />
